import { PublishStatus, LanguageType } from '../enum/ui-utils.enum';

import { ListFilter } from './filter.model';
import { SearchHighlights } from './search-highlight.model';
import { Tag, TagModel } from './tag.model';

export interface ArticleFilter extends ListFilter {
    status: PublishStatus;
    isActive: boolean;
}

export class ArticleFilterModel {
    skip: number;
    take: number;
    paging: boolean;
    startDate?: string;
    endDate?: string;
    searchString?: string;
    status: PublishStatus;
    isActive: boolean;

    constructor(private model: ArticleFilter) {
        this.skip = model.skip || 0;
        this.take = model.take || 10;
        this.paging = model.paging || true;
        this.startDate = model.startDate || '';
        this.endDate = model.endDate || '';
        this.searchString = model.searchString || '';
        this.status = model.status || PublishStatus.Published;
        this.isActive = model.isActive || true;
    }
}

export interface Article {
    id: string;
    title: string;
    shortDescription: string;
    description: string;
    publishedDate: string;
    attachmentId: number;
    imageUrl: string;
    tags: Tag[];
    status: PublishStatus;
    language: LanguageType;
    isActive: boolean;
    /** Optional highlights returned from search API */
    highlights?: SearchHighlights;
    /** Array of matched search tokens */
    matchedTokens?: string[];
}

export class ArticleModel {
    id: string;
    title: string;
    shortDescription: string;
    description: string;
    publishedDate: string;
    attachmentId: number;
    imageUrl: string;
    tags: TagModel[];
    status: PublishStatus;
    language: LanguageType;
    isActive: boolean;
    countHiddenTag: number;
    /** Optional highlights returned from search API */
    highlights?: SearchHighlights;
    /** Array of matched search tokens */
    matchedTokens?: string[];

    constructor(model: Article) {
        this.id = model.id;
        this.title = model.title;
        this.shortDescription = model.shortDescription;
        this.description = model.description;
        this.publishedDate = model.publishedDate;
        this.attachmentId = model.attachmentId;
        this.imageUrl = model.imageUrl;
        this.tags = model.tags ? model.tags.map((m) => new TagModel(m)) : [];
        this.status = model.status;
        this.language = model.language;
        this.isActive = model.isActive;
        this.countHiddenTag = 0;
        this.highlights = model.highlights;
        this.matchedTokens = model.matchedTokens;
    }
}
